<template>
<div>
  <van-tabbar route v-if="show">
    <van-tabbar-item replace to="/" icon="home-o" active-color="#016bff" inactive-color="#aeaeae">
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? imgIcon.home1 : imgIcon.home0" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/order" icon="shop-o">
      <span>订单</span>
      <template #icon="props">
        <img :src="props.active ? imgIcon.order1 : imgIcon.order0" />
      </template>        
    </van-tabbar-item>
  </van-tabbar>
  <div style="height: 50px;" v-if="show"></div>
</div>
</template>

<script>
function getIcon(name) {
  return require(`@/assets/images/nav/icon-${name}.png`)
}
export default {
  props: ['show'],
  data() {
    return {
      activeTab: 0,
      imgIcon: {
        home0: getIcon('home0'),
        home1: getIcon('home1'),
        visit0: getIcon('visit0'),
        visit1: getIcon('visit1'),
        customer0: getIcon('customer0'),
        customer1: getIcon('customer1'),
        order0: getIcon('order0'),
        order1: getIcon('order1'),
      },
      
    }
  },
}
</script>

<style>

</style>